import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import * as shape from 'd3-shape';
import { fuseAnimations } from '@fuse/animations';
import { ProjectDashboardService } from './project.service';
import { FuseSidebarService } from '../../../../../@fuse/components/sidebar/sidebar.service';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import moment from 'moment';
import { DateServiceService } from 'app/shared/common/helper/dateservice';
import { FormControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'project-dashboard',
    templateUrl: './project.component.html',
    styleUrls: ['./project.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class ProjectDashboardComponent implements OnInit {
    projects: any[] = [];
    selectedProject: any = { name: '', id: '' };

    widgets: any;

    dateNow = Date.now();
    userName: string = '';
    assignedResources: any[] = [];
    commonRoles: any[] = [];
    rolesWorkValues = [];
    graphRoleValue: any[] = [];
    workDetail = [];
    totalWorkHours = '0';
    totalWorkHourSecond = '00:00';
    graphEmpValue: any[] = [];
    tabIndex = 0;
    startDate: Date;
    actualEndDate: any;
    extendedEndDate: any;
    graphValue = [];
    projectDetails: any[] = [];
    today = new Date();
    toDate: any;
    fromDate: any;
    totEmpHrs = '0';
    noRecord = [];
    billable = [];
    nonBillable = [];
    selectedRole: any;
    monthFilter = false;
    weekFilter = false;
    twoWeekFilter = false;
    rangeFilter = false;
    remainingDays: any;
    myControl = new FormControl();
    filteredOptions: Observable<any[]>;
    empRole: any;
    currentUser: any;
    back = false;
    backProject = false;
    @Output() sendProjectId = new EventEmitter();

    tableCols = [
        { field: 'position', header: 'S. No' },
        { field: 'resourceImg', header: 'Profile' },
        { field: 'name', header: 'Name' },
        { field: 'mail', header: 'Email' },
        { field: 'designation', header: 'Designation' },
        { field: 'department', header: 'Department' },
        { field: 'role', header: 'Role' },
        { field: 'resourceType', header: 'Resource Type' }
    ];
    filters = [
        { name: 'Month Filter', value: 'month' },
        { name: 'Date Range Filter', value: 'range' },
        { name: 'Hide Filter', value: 'hide' },
    ];
    empty: any;
    @Input() projectId: any;
    selectedProjectName: string;
    projectStartDate: any;
    start: any;
    projectMembersIds = [];
    worklogGraphValue: { labels: any[]; datasets: { label: string; data: any[]; backgroundColor: string[]; hoverBackgroundColor: string[]; }[]; };
    selectedDate: any;
    worklogDetail = [];
    public chartOptions = {
        scales: {
            yAxes: [{
                ticks: {
                    stepSize: 2,
                    beginAtZero: true
                }
            }]
        }
    }
    selectedProjectId: any;
    selectedProjectType: any;
    totalProjectHours: number;
    roleWorkHours: any;
    nonWorkingDays = [];
    datesInMonth = [];
    totalWorkingDays: number;
    averageWorkHoursByDay: any;
    tenantId: any;
    averageWorkSecondsByDay: string;


    /**
     * Constructor
     *
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {ProjectDashboardService} _projectDashboardService
     */
    constructor(
        private _fuseSidebarService: FuseSidebarService,
        private _projectDashboardService: ProjectDashboardService,
        private parseService: ParseService,
        private queryInterface: QueryInterface,
        private hardCodedValues: HardCodedValues,
        private dateService: DateServiceService,
        private spinner: NgxSpinnerService,
        private toastr: ToastrService,
        private storageConfiguration: StorageConfiguration,
        private route: ActivatedRoute,
        private router: Router
    ) {
        this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    async ngOnInit(): Promise<void> {
        this.spinner.show();
        this.currentUser = this.parseService.instance.User.current();
        this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
        let firstname = this.parseService.instance.User.current().get('firstName');
        let lastname = this.parseService.instance.User.current().get('lastName');
        this.userName = firstname + ' ' + lastname;
        this.getProjects();
        // this.route.params.subscribe(params => {
        //     this.projectId = params.id;
        // });

        if (this.projectId != undefined && this.projectId != '') {
            this.back = true;
            this.backProject = true;

            let queryInstance = this.parseService.instance.Object.extend('Project');
            let query = new this.parseService.instance.Query(queryInstance);
            query.equalTo('objectId', this.projectId);
            query.find().then(results => {
                results.forEach(element => {
                    this.selectedProjectName = element.get('projectInfo').projectName;
                    this.selectedProjectType = element.get('projectInfo').projectType;
                    this.projectStartDate = element.get('projectInfo').projectStartDate;
                    this.totalProjectHours = this.getHoursCount(element.get('resourceDetails').details);
                });
            });

        }
        else {
            this.back = false;
            this.backProject = false;
        }
        this.widgets = this._projectDashboardService.widgets;

        this.nonWorkingDays = [];
        this.datesInMonth = [];
        const currentYear = new Date().getFullYear();
        const holidaysInstance = this.parseService.instance.Object.extend('Holidays');
        const holidayQuery = new this.parseService.instance.Query(holidaysInstance);
        holidayQuery.equalTo('year', currentYear);
        const leaveResults = await holidayQuery.find();
        if (leaveResults.length > 0) {
            let holidayList = leaveResults[0].get('dateList') == undefined ? {} : leaveResults[0].get('dateList');
            for (let months in holidayList) {
                if (holidayList[months].length != 0) {
                    let parsedMonths = parseInt(months);
                    if (parsedMonths == new Date().getMonth()) {
                        holidayList[months].forEach(element => {
                            const officialLeaves = new Date(currentYear, parsedMonths, element);
                            const epochLeaves = officialLeaves.getTime();
                            this.nonWorkingDays.push((epochLeaves));
                        });
                    }
                }
            }
        }

        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth();
        var d = new Date();
        var getTot = daysInMonth((d.getMonth()) + 1, d.getFullYear()); //Get total days in a month
        function daysInMonth(month, year) {
            return new Date(year, month, 0).getDate();
        }
        for (let j = 1; j <= getTot; j++) {
            let datesAll = new Date(year, month, j);
            let dayOfWeek = datesAll.getDay();
            let dateOfMonth = datesAll.getDate();
            let isEvenWeek = Math.ceil(dateOfMonth / 7);
            let epochOddDates = datesAll.getTime();
            if (dayOfWeek == 0) {
                if (this.nonWorkingDays.indexOf(epochOddDates) === -1) {
                    this.nonWorkingDays.push((epochOddDates));
                }
            } if (dayOfWeek == 6 && isEvenWeek % 2 != 0) {
                if (this.nonWorkingDays.indexOf(epochOddDates) === -1) {
                    this.nonWorkingDays.push((epochOddDates));
                }
            }
            this.datesInMonth.push((epochOddDates));
        }
        for (const element of this.nonWorkingDays) {
            let find = this.datesInMonth.findIndex(x => x == element);
            this.datesInMonth.splice(find, 1);
        }
        let thisYear = new Date().getFullYear();
        let thisMonth = new Date().getMonth();
        let thisDate = new Date().getDate();
        let today = new Date(thisYear, thisMonth, thisDate);
        let workingDays = this.datesInMonth.filter(y => y <= today.getTime());
        this.totalWorkingDays = workingDays.length;
    }

    projectChange(): void {
        this.backProject = false;
        this.monthFilter = false;
        this.rangeFilter = false;
        this.clearFilter();
        this.tabChange(this.tabIndex);
        this.getProjectDates();
        this.empty = '';
        this.sendProjectId.emit(this.selectedProject.id)
        // this.router.navigate(['projectdashboard', { id: this.selectedProject.id }]);
        this.selectedProjectId = this.selectedProject.id;
        this.projectId = this.selectedProjectId;
        this.ngOnInit();
    }

    private getProjectDates(): void {
        let projectInfo = this.projectDetails.filter(x => x.id == this.selectedProject.id)[0].projectInfo;

        this.startDate = projectInfo.projectStartDate;
        this.actualEndDate = projectInfo.actualCompletionDate;
        this.extendedEndDate = projectInfo.extendedCompletionDate;
        if (this.actualEndDate == '' && this.extendedEndDate == '') {
            this.remainingDays = 0;
        }
        else if (this.extendedEndDate == '') {
            this.remainingDays = this.getDateDiff(this.startDate, this.actualEndDate);
        }
        else {
            this.remainingDays = this.getDateDiff(this.startDate, this.extendedEndDate);
        }
    }

    /*
    ** ==========================================================
    ** Get List Of Projects
    ** ==========================================================
    */
    getProjects(): void {
        let condition = [];
        let type = '';
        if (this.empRole == 'Admin') {
            condition = [
                { field: 'objectId', condition: 'descending' },
                { condition: 'include', value: 'client' },
                { condition: 'limit', value: 10000 },
                { condition: 'containedIn', field: 'projectInfo.currentStatus', value: ['New', 'In Progress'] },
                { condition: 'equalTo', field: 'tenantId', value: this.tenantId}, 
            ];
            type = 'Project';
        } else {
            condition = [
                { condition: 'include', value: 'project' },
                { condition: 'equalTo', field: 'status', value: 'Assigned' },
                { condition: 'limit', value: 10000 },
                { condition: 'equalTo', field: 'user', value: { __type: 'Pointer', className: '_User', objectId: this.currentUser.id } },
                { condition: 'equalTo', field: 'tenantId', value: this.tenantId},
            ];
            type = 'ProjectMembers';
        }
        this.projectList(type, condition);
    }

    projectList(type, condition): void {
        this.queryInterface.executeQuery(this.parseService, type, condition).then(results => {
            this.projects = [];
            this.projectDetails = [];
            let projectType;
            if (this.empRole === 'Admin') {
                results.forEach(element => {
                    let totalHours = 0;
                    if (element.get('projectType') == 'Sub-Project') {
                        projectType = element.get('projectInfo').addOnType;
                    } else {
                        projectType = element.get('projectType');
                    }
                    if (element.get('projectInfo').projectType == 'Fixed') {
                        totalHours = this.getHoursCount(element.get('resourceDetails').details);
                    }
                    else {
                        totalHours = 0;
                    }
                    this.projects.push({
                        id: element.id,
                        name: element.get('projectInfo').projectName,
                        projectType: projectType,
                        typeOfProject: element.get('projectInfo').projectType,
                        totalHours: totalHours
                    });
                    this.projectDetails.push({
                        id: element.id,
                        name: element.get('projectInfo').projectName,
                        projectInfo: element.get('projectInfo'),
                        projectType: projectType
                    });
                });
            } else {
                let projects = results.filter(x => x.get('project').get('projectType') === 'Project');
                projects.forEach(element => {
                    let totalHours = 0;
                    let project = element.get('project');
                    if (project.get('projectType') == 'Sub-Project') {
                        projectType = project.get('projectInfo').addOnType;
                    } else {
                        projectType = project.get('projectType');
                    }
                    if (element.get('projectInfo') != undefined) {
                        if (element.get('projectInfo').projectType == 'Fixed') {
                            totalHours = this.getHoursCount(element.get('resourceDetails').details);
                        }
                        else {
                            totalHours = 0;
                        }
                    }
                    if (project.get('projectInfo').currentStatus == 'New' || project.get('projectInfo').currentStatus == 'In Progress') {
                        this.projects.push({
                            id: project.id,
                            name: project.get('projectInfo').projectName,
                            projectType: projectType,
                            typeOfProject: element.get('projectInfo') != undefined ? element.get('projectInfo').projectType : '',
                            totalHours: totalHours
                        });
                        this.projectDetails.push({
                            id: project.id,
                            name: project.get('projectInfo').projectName,
                            projectInfo: project.get('projectInfo'),
                            projectType: projectType
                        });
                    }
                });
            }
            this.projects = this.projects.sort((a, b) => a.name.trim().localeCompare(b.name.trim()));
            if (this.projectId != undefined && this.projectId != '') {
                this.selectedProject.id = this.projectId;
            } else {
                this.selectedProject = this.projects[0];
            }
            this.tabChange(0);
            this.getFilteredValue();
        });
    }

    getHoursCount(data) {
        let total = 0;
        data.forEach(element => {
            total += element.hours;
        });
        return total;
    }
    /*
    ** ==========================================================
    ** Get Project Assigned Resources
    ** ==========================================================
    */
    async getAssignedResources(): Promise<void> {

        let projectMember = this.parseService.instance.Object.extend('ProjectMembers');
        let query = new this.parseService.instance.Query(projectMember);
        query.descending('objectId');
        query.include('project');
        query.include('user');
        query.include('user.profile');
        query.include('user.profile.department');
        query.limit(10000);
        query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.selectedProject.id });
        query.equalTo('status', 'Assigned')
        await query.find().then(results => {
            this.assignedResources = [];
            this.projectMembersIds = [];
            let resources = [];
            results.forEach(element => {
                let profile = element.get('user').get('profile');
                this.projectMembersIds.push(element.get('user').id);
                resources.push({
                    position: 0,
                    resourceId: profile.id,
                    name: profile.get('username'),
                    department: profile.get('department').get('name'),
                    resourceImg: profile.get('profileImageInfo').url == undefined ? this.hardCodedValues.defaultProfileImg : profile.get('profileImageInfo').url,
                    mail: profile.get('officialInfo').officialEmail,
                    designation: profile.get('department').get('name'),
                    role: element.get('role'),
                    resourceType: element.get('resourcesType')
                });
            });
            let res = resources.sort((a, b) => a.name.localeCompare(b.name));
            res.forEach((element, index) => {
                element.position = index + 1;
            });
            this.assignedResources = res;

            // let dedicatedList = res.filter(x => x.resourceType == 'Fixed-Billable' || x.resourceType == 'Dedicated-Billable');
            // let nonBillableList = res.filter(x => x.resourceType == 'Dedicated Proxy' || x.resourceType == 'Fixed Non-Billable' || x.resourceType == 'Dedicated Non-Billable' || x.resourceType == 'Bench' || x.resourceType == 'Trainee');

            // let dedicatedList = res.filter(x => x.resourceType == 'Fixed-Billable' || x.resourceType == 'Fixed-Billable' || x.resourceType == 'Time and Material Billable');
            // let nonBillableList = res.filter(x => x.resourceType == 'Dedicated Proxy' || x.resourceType == 'Fixed Non-Billable' || x.resourceType == 'Dedicated Non-Billable' || x.resourceType == 'Bench' || x.resourceType == 'Trainee' || x.resourceType == 'Time and Material Non-Billable');

            let dedicatedList = res.filter(x => x.resourceType == 'Billable' );
            let nonBillableList = res.filter(x => x.resourceType == 'Non-Billable');
            let billable = [];
            dedicatedList.forEach(element => {
                billable.push(element);
            });
            this.billable = billable;
            this.nonBillable = nonBillableList;
        }).catch(error => {
            return [];
        });
    }

    getAssignedResourceId(startendDates) {
        let membersIds = [];
        let projectId = this.selectedProject.id;
        let projectMember = this.parseService.instance.Object.extend('ProjectMembers');
        let query = new this.parseService.instance.Query(projectMember);
        query.include('project');
        query.include('user');
        query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: projectId });
        query.find().then(members => {
            members.forEach(element => {
                membersIds.push({ id: element.get('user').id, role: element.get('role') });
            });
            let ids = this.getUnique(membersIds, 'id');
            this.getProjectDates();
            this.getTimeSheetDetails(ids, startendDates);
        });
    }

    getUnique(arr, comp): any {
        const unique = arr.map(e => e[comp]).map((e, i, final) => final.indexOf(e) === i && i).filter(e => arr[e]).map(e => arr[e]);
        return unique;
    }

    /*
    ** ==========================================================
    ** Get Timesheet Details
    ** ==========================================================
    */
    getTimeSheetDetails(membersIds, startendDates,) {
        this.spinner.show();
        let ids = [];
        membersIds.forEach(element => {
            ids.push(element.id);
        });
        let timeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
        let query = new this.parseService.instance.Query(timeSheet);
        query.include('user');
        query.include('user.profile');
        query.include('user.profile.department');
        query.include('user.profile.role');
        query.greaterThan('createdAt', startendDates[0]);
        query.lessThan('createdAt', startendDates[1]);
        query.containedIn('user', ids);
        query.limit(1000000);
        query.find().then(results => {
            let workDetails = [];
            let projectId = this.selectedProject.id;
            membersIds.forEach(member => {
                let timeSheets = results.filter(x => x.get('user').id == member.id);
                let workHours = 0;
                let userName = '';
                let userDepartment = '';

                if (timeSheets.length > 0) {
                    timeSheets.forEach(tSheet => {
                        let userProfile = tSheet.get('user').get('profile');
                        userName = userProfile.get('firstName');
                        let department = userProfile.get('department');
                        userDepartment = department.get('name');
                        let role = '';
                        let totalAttendance = tSheet.get('totalAttendance');
                        let workDatas = totalAttendance.project.filter(a => a.id == projectId);
                        workDatas.forEach(workData => {
                            workHours += workData.actualHours;
                        });
                    });
                    if (workHours > 0) {
                        workDetails.push({ position: 0, name: userName, id: member.id, workHours: workHours, userDepartment: userDepartment, role: member.role });
                    }
                }
            });
            this.workDetail = workDetails.sort(function (a, b) { return b.workHours - a.workHours; });
            let commonValues = [];
            this.commonRoles = [];
            commonValues = this.getUnique(membersIds, 'role');
            commonValues.forEach(element => {
                this.commonRoles.push(element.role);
            });
            let rolesValue = [];
            this.commonRoles.forEach(element => {
                let filteredValue = this.workDetail.filter(x => x.role == element);
                let wrkHrs = 0;
                filteredValue.forEach(innerElement => {
                    wrkHrs += innerElement.workHours;
                });
                rolesValue.push({ role: element, wrkHrs: wrkHrs });
            });

            this.rolesWorkValues = rolesValue;
            this.graphValue = [];
            this.graphEmpValue = [];
            this.detailsToGraph(rolesValue, 'role');
            let totalHrs = 0;
            this.workDetail.forEach((element, index) => {
                element.position = index + 1;
                totalHrs += element.workHours;
                // element.workHours = this.secondsToHms(Math.ceil(element.workHours / 1000));
            });
            this.totEmpHrs = '0';
            this.totalWorkHours = '0';
            this.totalWorkHours = this.secondsToHms(Math.ceil(totalHrs / 1000));
            this.totalWorkHourSecond = this.secondsToHm(Math.ceil(totalHrs / 1000));
            this.averageWorkHoursByDay = Number((Number(this.totalWorkHours)) / this.totalWorkingDays).toFixed(2);
            this.averageWorkSecondsByDay = Number((Number(this.totalWorkHours)) / this.totalWorkingDays).toFixed(2);
            let roleval = rolesValue.sort(function (a, b) { return b.wrkHrs - a.wrkHrs; });
            let empRoleValues = this.workDetail.filter(x => x.role == roleval[0].role);
            if (empRoleValues.length > 0) {
                this.selectedRole = empRoleValues[0].role == undefined ? '' : empRoleValues[0].role;
                this.getProjectEstimatedHours(this.selectedRole);
            }
            this.detailsToGraph(empRoleValues, 'employee');
            this.spinner.hide();

        });
    }

    detailsToGraph(workDetails, type) {
        let names = [];
        let workHrs = [];
        let graphVal = [];
        let totEmpHrs = 0;
        workDetails.forEach(element => {
            if (element.role != '' && element.role != undefined) {
                let name = type == 'role' ? element.role : element.name;
                let hours = type == 'role' ? element.wrkHrs : element.workHours;
                totEmpHrs += hours;
                let hrs = Math.round(Math.ceil(hours / 1000) / 3600);
                graphVal.push({ name: name, value: Number(hrs) });
            }
        });
        if (type === 'role') {
            this.noRecord = graphVal.filter(x => x.value == 0);

        }
        if (type == 'role') {
            this.graphValue = graphVal;
        } else {
            this.graphEmpValue = graphVal;
            this.totEmpHrs = this.secondsToHms(Math.ceil(totEmpHrs / 1000));
        }
    }

    secondsToHm(d) {
        d = Number(d);
        var h = Math.floor(d / 3600);
        var m = Math.floor(d % 3600 / 60);
        var s = Math.floor(d % 3600 % 60);
    
        var hDisplay = (h <= 9 ? '0' : '') + h;
        var mDisplay = (m <= 9 ? '0' : '') + m;
    
        return hDisplay + ':' + mDisplay;
      }

    secondsToHms(d) {
        d = Number(d);
        let h = Math.floor(d / 3600);
        // let m = Math.floor(d % 3600 / 60);
        // let s = Math.floor(d % 3600 % 60);

        let hDisplay = (h <= 9 ? '0' : '') + h;
        // let mDisplay = (m <= 9 ? '0' : '') + m;
        // let sDisplay = (s <= 9 ? '0' : '') + s;
        // return hDisplay + ':' + mDisplay;
        return hDisplay
    }

    async tabChange(index): Promise<void> {
        this.tabIndex = index;
        switch (index) {
            case 0:
                this.spinner.show();
                let today = new Date();
                let date = new Date().getDate() >= 10 ? new Date() : new Date(today.getFullYear(), today.getMonth(), 0);
                let startendDates = this.dateService.startEndDateByMonth(date);
                this.getAssignedResources();
                this.getAssignedResourceId(startendDates);
                this.monthFilter = false;
                this.rangeFilter = false;
                this.clearFilter();
                this.fromDate = '';
                this.toDate = '';
                break;
            case 1:
                await this.getAssignedResources();
                this.getWorkHours();
                break;
        }
    }

    async getWorkHours() {
        this.worklogDetail = [];
        let startend = this.startenddates(this.selectedDate ? this.selectedDate : new Date());
        let timeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
        let query = new this.parseService.instance.Query(timeSheet);
        query.include('user');
        query.include('user.profile');
        query.include('user.profile.department');
        query.greaterThan('createdAt', startend[0]);
        query.lessThan('createdAt', startend[1]);
        query.containedIn('user', this.projectMembersIds);
        query.limit(1000000);
        await query.find().then(results => {
            let worklogDetails = [];
            this.projectMembersIds.forEach(id => {
                let timeSheets = results.filter(x => x.get('user').id == id);
                let workHours = 0;
                let userName = '';
                if (timeSheets.length > 0) {
                    timeSheets.forEach(tSheet => {
                        let userProfile = tSheet.get('user').get('profile');
                        userName = userProfile.get('firstName') + ' ' + userProfile.get('lastName');
                        let totalAttendance = tSheet.get('totalAttendance');
                        let workDatas = totalAttendance.project.filter(a => a.id == this.projectId);
                        workDatas.forEach(workData => {
                            workHours += workData.actualHours;
                        });
                    });
                    if (workHours > 0) {
                        worklogDetails.push({ position: 0, name: userName, id: id, workHours: workHours });
                    }
                }
            });
            this.detailsToWorklogGraph(worklogDetails);
            this.worklogDetail = worklogDetails.sort(function (a, b) { return b.workHours - a.workHours });
            let totalHrs = 0;
            this.workDetail.forEach((element, index) => {
                element.position = index + 1;
                totalHrs += element.workHours;
                element.workHours = this.secondsToHms(Math.ceil(element.workHours / 1000));
            });
            // this.totalWorkHours = this.secondsToHms(Math.ceil(totalHrs / 1000));
        });
    }

    detailsToWorklogGraph(worklogDetails) {
        let names = [];
        let workHrs = [];
        worklogDetails.forEach(element => {
            names.push(element.name);
            workHrs.push((Math.ceil(element.workHours / 1000) / 3600).toFixed(1));
        });
        this.worklogGraphValue = {
            labels: names,
            datasets: [
                {
                    label: 'Work Hours',
                    data: workHrs,
                    backgroundColor: [
                        '#9370DB',
                        '#008080',
                        '#999999',
                        '#C7B42C',
                        '#808000',
                        '#5AA454',
                        '#800080',
                        '#FF00FF',
                        '#000080',
                        '#008080',
                        '#00FFFF',
                        '#FFC0CB',
                        '#FF7F50',
                        '#800000',
                        '#333300'
                    ],
                    hoverBackgroundColor: [
                        '#9370DB',
                        '#008080',
                        '#999999',
                        '#C7B42C',
                        '#808000',
                        '#5AA454',
                        '#800080',
                        '#FF00FF',
                        '#000080',
                        '#008080',
                        '#00FFFF',
                        '#FFC0CB',
                        '#FF7F50',
                        '#800000',
                        '#333300'
                    ]
                }]
        };
    }

    startenddates(day) {
        let startdate = this.daybefore(new Date(day));
        startdate.setHours(23, 59, 59, 999);
        let enddate = this.dayafter(day);
        enddate.setHours(0, 0, 0, 0);
        return [startdate, enddate];
    }

    dayafter(d) {
        let day = new Date(d);
        return new Date(day.setDate(day.getDate() + 1));
    }

    daybefore(d) {
        let day = new Date(d);
        return new Date(day.setDate(day.getDate() - 1));
    }

    graphRoleSelected(event): void {
        this.selectedRole = event.name;
        let roleValues = this.workDetail.filter(x => x.role == event.name);
        this.detailsToGraph(roleValues, 'employee');

        this.getProjectEstimatedHours(event.name);
    }

    async getProjectEstimatedHours(roleName) {
        let projectId = this.projectId ? this.projectId : this.selectedProject.id;
        let projectMember = this.parseService.instance.Object.extend('Project');
        let query = new this.parseService.instance.Query(projectMember);
        query.equalTo('objectId', projectId);
        await query.find().then(result => {
            let workHours = result[0].get('resourceDetails').details;
            let data = workHours.filter(x => x.role == roleName);
            this.roleWorkHours = data[0].hours;
        });
    }

    getDateDiff(start, end): Number {
        // end = end == '' ? new Date() : end;

        const daydiff = moment(end).diff(moment(start), 'days');
        let totalDays = Math.abs(daydiff);
        const toDaydiff = moment(new Date()).diff(moment(start), 'days');
        let diff = totalDays - toDaydiff;

        // var diff = Math.abs(new Date(start).getTime() - new Date(end).getTime());
        // var diffDays = Math.ceil(diff / (1000 * 3600 * 24));

        return diff > 0 ? diff : 0;
    }

    monthClick(): void {
        this.monthSelector(new Date());
    }

    weekClick(): void {
        this.weekSelector(new Date());
    }

    twoWeeksClick(): void {
        this.twoWeeksSelector(new Date());
    }

    allRecord(): void {
        let queryInstance = this.parseService.instance.Object.extend('Project');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('objectId', this.selectedProject.id);
        query.find().then(async results => {
            this.projectStartDate = results[0].get('projectInfo').projectStartDate;
            await this.fullRecordSelector(this.projectStartDate, new Date());

        });
    }

    monthSelector(event): void {
        let startendDates = this.dateService.startEndDateByMonth(event);
        if (startendDates.length > 0) {
            startendDates[1].setHours(23, 59, 59, 999);
        }
        this.getAssignedResourceId(startendDates);
    }

    weekSelector(event): void {
        let startendDates = this.dateService.getLastWeekFilter(event);
        if (startendDates.length > 0) {
            startendDates[1].setHours(23, 59, 59, 999);
        }
        this.getAssignedResourceId(startendDates);
    }

    twoWeeksSelector(event): void {
        let startendDates = this.dateService.getLastTwoWeeks(event);
        if (startendDates.length > 0) {
            startendDates[1].setHours(23, 59, 59, 999);
        }
        this.getAssignedResourceId(startendDates);
    }

    fullRecordSelector(startDate, endDate): void {
        let projectDate = new Date(startDate)

        let startendDates = this.dateService.getFullRecord(projectDate, endDate);
        this.getAssignedResourceId(startendDates)
    }

    getToday(): any {
        let d = new Date();
        let yesterday = new Date(d.setDate(d.getDate() - 1));
        return new Date(yesterday);
    }

    getRangeValue(): void {
        if (this.fromDate != undefined && this.fromDate != '' && this.toDate != undefined && this.toDate != '') {
            let date = this.toDate == undefined || this.toDate == '' ? new Date() : this.toDate;
            let startDate = this.dateService.startEndDateByDate(this.fromDate);
            let endDate = this.dateService.startEndDateByDate(date);
            let startEndDate = [startDate[0], endDate[1]];
            this.getAssignedResourceId(startEndDate);
        } else {
            this.toastr.warning('Please select from date and to date');
        }
    }

    selectFilter(event): void {
        this.monthFilter = event.value == 'month';
        this.weekFilter = event.value == 'week';
        this.twoWeekFilter = event.value == 'twoWeeks'
        // this.rangeFilter = event.value == 'range';
        if (event.value == 'month') {
            this.monthSelector(new Date());
        }
        if (this.fromDate != undefined && this.fromDate != '' && this.toDate != undefined && this.toDate != '' && event.value == 'range') {
            this.getRangeValue();
        }
        if (event.value == 'week') {
            this.weekSelector(new Date());
        }
        if (event.value == 'twoWeeks') {
            this.twoWeeksSelector(new Date());
        }
    }

    clearFilter(): void {
        this.monthSelector(new Date());
    }

    getFilteredValue() {
        if (this.projects.length > 0) {
            this.filteredOptions = this.myControl.valueChanges.pipe(
                startWith(''),
                map(skillSets => this._filter(skillSets))
            );
        }
    }

    private _filter(value: string): any[] {
        let projects = JSON.stringify(this.projects);
        let projectList = JSON.parse(projects);
        const filterValue = value.toLowerCase();
        return projectList.filter(option => option.name
            .toString()
            .toLowerCase()
            .includes(filterValue)
        );
    }

    async goToSprint() {
        let result = [];
        let queryInstance = this.parseService.instance.Object.extend('Sprint');
        let query = new this.parseService.instance.Query(queryInstance);
        query.include('project');
        query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.selectedProject.id });
        await query.find().then(results => {
            result = results;
            if (result.length > 0) {
                this.router.navigate(['/scrumboard/board/sprint/' + this.selectedProject.id + '/' + this.selectedProject.name]);
            }
            else {
                this.toastr.warning('Please create backlog board');
            }
        });
    }

    backlocation() {
        this.router.navigate(['project-metrics']);
    }

    /**
     * Toggle the sidebar
     *
     * @param name
     */
    toggleSidebar(name): void {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }

}
